import _ from 'lodash';

import {
  CLEAR_SAVED_FILTERS,
  SAVE_SAVED_SEARCH_FILTERS,
  SET_LAST_SELECTED_REPOSITORY_NAME,
  SET_LAST_SELECTED_SEARCH_NAME,
} from '../actions/SavedSearchFiltersActions';

const savedSearchFilters = (state = {}, action) => {
  switch (action.type) {
    case SAVE_SAVED_SEARCH_FILTERS: {
      const { searchName, savedSearchData } = action.payload;

      return { ...state, [searchName]: savedSearchData };
    }

    case CLEAR_SAVED_FILTERS: {
      const { searchName } = action.payload;

      const newState = _.omit(state, [searchName]);

      return { ...newState };
    }

    case SET_LAST_SELECTED_SEARCH_NAME: {
      const { key, searchName } = action.payload;

      const prevSelectedState = state?.lastSelectedSearchNames || {};

      return {
        ...state,
        lastSelectedSearchNames: { ...prevSelectedState, [key]: searchName },
      };
    }

    case SET_LAST_SELECTED_REPOSITORY_NAME: {
      const { repositoryName } = action.payload;

      return {
        ...state,
        lastSelectedRepositoryName: repositoryName,
      };
    }

    default:
      return state;
  }
};

export default savedSearchFilters;
